<template>
  <div class="sui-chips" :style="styles" @pointerdown.prevent @click.stop="onclick">
    <div class="sui-chips__title"> {{ label }} </div>
    <div class="sui-chips__icon">
      <Icon :name="icon" :size="'tn'" @click.stop="onIconClick"></Icon>
    </div>
  </div>
</template>

<script setup lang="ts">
import { CSSProperties, PropType, toRefs } from 'vue'

// Components
import Icon from '../icon/Icon.vue'

const props = defineProps({
  label: {
    type: String,
    default: ''
  },
  icon: {
    type: String,
    default: 'close'
  },
  styles: {
    type: Object as PropType<CSSProperties>,
    default: null
  }
})

const { label, icon } = toRefs(props)

const emit = defineEmits(['click', 'icon-click'])

function onclick() {
  emit('click')
} 

function onIconClick() {
  emit('icon-click')
}
</script>

<style scoped lang="scss">
  .sui-chips {
    display: flex;
    overflow: hidden;
    flex-wrap: nowrap;
    align-items: center;
    background-color: var(--color-hint);
    height: 20px;
    padding: 2px 8px;
    color: var(--color-text-contrast);
    border-radius: 4px;
    gap: 8px;
    font-size: 12px;
    line-height: 16px;
    font-weight: 400;
    max-width: 100%;

    &__title {
      max-width: 100%;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &__icon {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
      cursor: pointer;
    }
  }
</style>
